import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Reveal from "./Reveal";

export default function LegalDoc({ doc, prefix }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="relative overflow-hidden pt-32 md:pt-40 pb-24 md:pb-32">
      <div className="pointer-events-none absolute -top-40 -right-40 h-[420px] w-[420px] rounded-full bg-violet-600/12 blur-[130px]" />
      <div className="pointer-events-none absolute top-1/2 -left-48 h-[380px] w-[380px] rounded-full bg-cyan-500/10 blur-[120px]" />

      <div className="relative mx-auto max-w-3xl px-4 sm:px-6">
        <Link
          to="/"
          data-testid={`${prefix}-back-link`}
          className="inline-flex items-center gap-2 min-h-12 px-5 rounded-full border border-white/15 text-sm font-semibold text-slate-200 hover:border-cyan-400/60 hover:text-cyan-300 transition-colors duration-300"
        >
          <ArrowLeft className="w-4 h-4" />
          {doc.back}
        </Link>

        <Reveal>
          <h1 data-testid={`${prefix}-title`} className="font-display mt-8 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {doc.title}
          </h1>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-4 font-mono-accent text-xs uppercase tracking-[0.25em] text-slate-500">
            {doc.updated}
          </p>
        </Reveal>

        <div className="mt-14 space-y-12">
          {doc.sections.map((s, i) => (
            <Reveal key={s.h} delay={Math.min(i * 0.05, 0.3)}>
              <section data-testid={`${prefix}-section-${i + 1}`} className="border-l-2 border-cyan-400/25 pl-6">
                <h2 className="flex items-baseline gap-4 font-display text-xl sm:text-2xl font-semibold tracking-tight">
                  <span className="font-mono-accent text-sm font-semibold text-vortex-gradient">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {s.h}
                </h2>
                <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed whitespace-pre-line">{s.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
